import { ApiError } from '$utils/services/apiErrorService'
import { errors } from '$views/components/Error/serverErrors'

const titlesErrorList: any = [
  'USER_NOT_ACTIVE',
  'EMAIL_DOES_NOT_EXIST',
  'INVALID_CREDENTIALS',
  'UNAUTHORIZED',
  'INVALID_USER',
]

const getTitle = (msgError: string[]) => {
  if (msgError.length > 1) {
    return errors.title.default
  }
  const title = titlesErrorList.find(titleError => msgError.indexOf(titleError) !== -1)
  if (title) {
    return errors.title[title.toLowerCase()]
  }
  return ''
}

export const formatError = (error: ApiError) => {
  const title = getTitle(error.data.MENSAJE_ERROR)
  const type = error.data.ERROR_CODE
  let text = error.data.MENSAJE_ERROR.map(msgError => errors[msgError.toLowerCase()])

  if (text.length === 0) {
    text = [errors.default]
  }

  return { title, text, type }
}



// WEBPACK FOOTER //
// ./src/views/components/Error/Error.mapper.ts